import {
  FETCH_USERS,
  SET_IS_LOADING_USERS,
  FETCH_USER,
  SET_IS_LOADING_USER,
  SET_USER_PREFERENCES,
  SET_USERS,
  SWITCH_USER_VIEW,
} from "redux/constants/portal";

export const fetchUsers = (tenant_id) => ({
  type: FETCH_USERS,
  payload: { tenant_id },
});
export const setIsLoadingUsers = (payload) => ({
  type: SET_IS_LOADING_USERS,
  payload,
});
export const fetchUser = (tenant_id, auth0_id) => ({
  type: FETCH_USER,
  payload: { tenant_id, auth0_id },
});
export const setIsLoadingUser = (payload) => ({
  type: SET_IS_LOADING_USER,
  payload,
});
export const setUserPreferences = (payload) => ({
  type: SET_USER_PREFERENCES,
  payload,
});
export const setUsers = (payload) => ({
  type: SET_USERS,
  payload,
});
export const switchUserView = (payload) => ({
  type: SWITCH_USER_VIEW,
  payload,
});
